import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CurrencyTemplate from '../currencyTemplate';

const useStyles = makeStyles((theme) => ({
  introPriceText: {
    borderRadius: '10px',
    border: '3px solid #ffd300',
    backgroundColor: `${theme.palette.custom.lightBlack}`,
    padding: '2px 5px',
    color: '#fff',
    fontFamily: 'titillium-regular',
    fontSize: '13px',
    letterSpacing: '.5px',
    fontWeight: '500',
    display: 'inline-block',
    lineHeight: '15px',
    marginBottom: '5px',
    textTransform: 'uppercase',
  },
  introPriceViewContainer: {
    fontFamily: 'titillium-regular',
    fontSize: '13px',
    letterSpacing: '.5px',
    fontWeight: '500',
  },
  fontSet: {
    fontSize: '25px',
    fontWeight: 'bold',
    lineHeight: '26px',
  },
  fontWeightSet: {
    fontWeight: 700,
  },
  inlineBlockSet: {
    display: 'inline-block',
    marginRight: '5px',
  },
  dashedBorder: {
    borderTop: `1px dashed ${theme.palette.custom.frame}`,
  },
  discountFontSet: {
    fontWeight: 500,
    fontSize: '13px',
    textTransform: 'none',
  },
}));

const IntroPricingSubscriptionAmount = ({ introPricing }) => {
  const classes = useStyles();
  const {
    afterDiscountPrefix,
    afterDiscountPrice,
    afterDiscountSuffix,
    discountPrice,
    discountPriceLineCurrencySymbol,
    discountPricePeriod,
    introPricingLabel,
    prefixCurrencySymbol,
  } = introPricing;
  return (
    <Box className={classes.introPriceViewContainer}>
      <Box className={classes.introPriceText}>{introPricingLabel}</Box>
      <Box pb={1}>
        <CurrencyTemplate
          prefixCurrencySymbol={prefixCurrencySymbol}
          fontSetClass={classes.fontSet}
          inlineBlockSetClass={classes.inlineBlockSet}
          discountPriceCurrencySymbol={discountPriceLineCurrencySymbol}
          price={discountPrice}
          isDiscountPrice={true}
        />
        <span
          className={`${classes.inlineBlockSet} ${classes.discountFontSet}`}
        >
          {discountPricePeriod}
        </span>
      </Box>
      <Box className={classes.dashedBorder} pt={2}>
        <span className={classes.inlineBlockSet}>{afterDiscountPrefix}</span>
        <CurrencyTemplate
          prefixCurrencySymbol={prefixCurrencySymbol}
          inlineBlockSetClass={classes.inlineBlockSet}
          fontWeightSetClass={classes.fontWeightSet}
          discountPriceCurrencySymbol={discountPriceLineCurrencySymbol}
          price={afterDiscountPrice}
        />
        <span className={classes.inlineBlockSet}>{afterDiscountSuffix}</span>
      </Box>
    </Box>
  );
};

export default IntroPricingSubscriptionAmount;
